<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
     v-if="asset != null"
>
    <m-image-size-control
        v-model="max_size"
    />

    <m-blob-card
        v-for="(item, index) in blob_meta_data"
        :key="'blob_card_'+index"
        :value="item"
        :max_size="max_size"
        v-on:delete="onClickDelete(index)"
    />

    <div
        style="clear: both;"
    />

    <m-icon-bar
        v-on:add="onClickAdd"
    />


    <v-text-field
        label="Label"
        v-model="asset.label"
        v-on:input="save"
    />

    <v-checkbox
        label="Archived"
        v-model="asset.archived"
        v-on:click="doSave"
        style="margin-top: -5px"
    />

    <m-edit-blobs-dialog
        ref="edit-blobs-dialog"
        v-on:ok="afterEditBlobsDialog($event)"
        :externally_visible="true"
        :allow_multiple="true"
        purpose="attachment"
        title="Add Media Asset"
        :allow_media_assets="false"
        :organization_id="$route.params.organization_id"
        dialog_hint="<b>Image Size / Format:</b>  Images should be square, no more than 1000 x 1000 pixels, in JPEG format, usign the sRGB color space and, for bottle shots, be on a solid background (white preferred)."
    />

</v-container>
</m-pageframe>
</template>

<script>
import mIconBar from '../../components/input/m-icon-bar.vue';
const _ = require('lodash');
export default {
  components: { mIconBar },
    data() {
        return {
            asset: null,
            blob_meta_data: [],
            max_size: 300,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/media-assets/get-or-create-stub',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'created_by_content_type': this.$route.params.content_type,
                        'asset_id': this.$route.params.asset_id,
                    },
            
                'on_success': (data) => {
                        this.asset = data.asset;
                        this.blob_meta_data = data.blob_meta_data;
                    },
            
                'on_error': 'Unable to get asset',
            });
        },



        save: _.debounce(function(){
            this.doSave();
        }, 751),
        
        doSave(update_after_save)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/media-assets',
            
                'params' : this.asset,
            
                'on_success': (data) => {
                    if ( update_after_save == true )
                    {
                        this.doUpdate();
                    }
                },
            
                'on_error': 'Unable to save changes to media asset',
            });
        },
        
        onClickAdd()
        {
            this.$refs['edit-blobs-dialog'].showDialog();
        },

        afterEditBlobsDialog(blob_ids)
        {
            this.asset.blob_ids = this.asset.blob_ids.concat(blob_ids);
            this.doSave(true);
        },

        onClickDelete(index)
        {
            this.$rc.confirm({
                'title': 'Delete',
                'body': 'Permenantly delete this image?',
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    
                    this.asset.blob_ids.splice(index,1);
                    this.doSave(true);
                },
            });
        },
    },

    computed: {
        title() {
            if ( this.asset == null ) return '{organization-label}: Edit Media Asset';

            return '{organization-label}: '+this.asset.label; 
        }
    },
}
</script>

<style lang="scss" scoped>
</style>